// Pusher event types + de-dupe helpers for the talent SPA. STERLING's messages +
// thread-state nudges arrive on `private-seller-{id}` as their own event types
// (NOT wrapped in the agent.stream envelope). Each carries `turn_id` + `seq` so we
// de-dupe redelivery / StrictMode double-mounts (doctrine 1.3); the dispatcher
// (seller-stream-dispatcher.ts) then folds each into the Query cache — setQueryData
// for a `seller.message`, invalidate the touched thread for a `seller.thread.update`,
// resolve the thread's PDF button for a `seller.export.ready`.

import type { SellerExportReady, SellerMessageEvent, SellerThreadUpdate } from "@recruiter/shared";

export type SellerLiveEvent = SellerMessageEvent | SellerThreadUpdate | SellerExportReady;

export const SELLER_EVENT_NAMES = [
  "seller.message",
  "seller.thread.update",
  "seller.export.ready",
] as const;

/** Stable de-dupe key for an event (mirrors web's `${turn_id}:${seq}`). */
export function streamEventKey(ev: SellerLiveEvent): string {
  return `${ev.turn_id}:${ev.seq}`;
}

/** Which thread an event touches (the dispatcher keys its cache writes by this). */
export function affectedThreadId(ev: SellerLiveEvent): string {
  return ev.thread_id;
}
